import { getRouteApi } from '@tanstack/react-router'

const rootApi = getRouteApi('__root__')

export function useUser() {
	const user = rootApi.useRouteContext({ select: (ctx) => ctx.user })
	if (!user) throw new Error('useUser called outside authenticated route')

	const username = user.profile.preferred_username?.split('@')[0] ?? ''
	const displayName = user.profile.name ?? user.profile.preferred_username ?? ''
	const firstName = user.profile.given_name ?? ''
	const lastName = user.profile.family_name ?? ''
	const initials = `${user.profile.given_name?.charAt(0)?.toUpperCase() ?? ''}${user.profile.family_name?.charAt(0)?.toUpperCase() ?? ''}`
	const email = user.profile.email ?? ''

	return { user, username, displayName, firstName, lastName, initials, email }
}
